import React from "react";
import { Code as CodeIcon, Star as StarIcon } from "@mui/icons-material";
import { Language } from "../../../../SourceModal.types";

interface BaseOverviewProps {
    language: Language;
    title?: string;
    showDataPointOverview?: boolean;
    showDescription?: boolean;
    children?: React.ReactNode;
}

const BaseOverview: React.FC<BaseOverviewProps> = ({
    language,
    title,
    showDataPointOverview = true,
    showDescription = true,
    children,
}) => {
    return (
        <div>
            {title && <h1 className="mb-3">{title}</h1>}

            {showDescription && (
                <p className="mb-3">
                    {language?.tracker_detail?.overview?.message ??
                        "Signalsight.io seamlessly integrates a diverse array of data sources and destinations, enabling comprehensive and real-time data flow across your marketing and sales platforms. From website interactions and offline events to CRM systems and mobile apps, our platform ensures accurate data synchronization, empowering you to make data-driven decisions. With robust support for major advertising channels, including Meta, TikTok, Snap, and Pinterest, Signalsight.io optimizes your campaigns and enhances your customer insights for superior marketing performance."}
                </p>
            )}

            {showDataPointOverview && (
                <div className="source-detail-modal-card mb-3">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 source-detail-modal-card-border-right">
                            <h2>
                                {language?.tracker_detail?.overview
                                    ?.data_point_overview ??
                                    "Data Point Overview"}
                            </h2>
                            <span className="title">
                                <CodeIcon />{" "}
                                {language?.tracker_detail?.overview?.source ??
                                    "Source"}
                            </span>
                            <p className="mb-2">
                                {language?.tracker_detail?.overview
                                    ?.source_msg ??
                                    "Your data origin - where customer interactions and behaviors are captured. Examples include websites, apps, or CRM systems."}
                            </p>
                            <span className="title">
                                <StarIcon />{" "}
                                {language?.tracker_detail?.overview?.features ??
                                    "Features"}
                            </span>
                            <p className="mb-1">
                                {language?.tracker_detail?.overview
                                    ?.feature_1 ??
                                    "-Real time event transmission"}
                            </p>
                            <p>
                                {language?.tracker_detail?.overview
                                    ?.feature_2 ?? "-No data storing"}
                            </p>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <h2>
                                {language?.tracker_detail?.overview
                                    ?.setup_requirements ??
                                    "Set up Requirements"}
                            </h2>
                            <p className="mb-2">
                                {language?.tracker_detail?.overview
                                    ?.destination_setup_requirements_1 ??
                                    "There will be a minimum of 2 node points to connect with."}
                            </p>
                            <p>
                                {language?.tracker_detail?.overview
                                    ?.destination_setup_requirements_2 ??
                                    "These are referred to as the Source and the Destination."}
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {children}
        </div>
    );
};

export default BaseOverview;
